export default __webpack_public_path__ + "static/media/message_received.ba861b09.mp3";